import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PurchaseregHeader from "../../purchase_elements/PurchaseregHeader/PurchaseregHeader";
import DataTable from "../../purchase_elements/table/DataTable";
import PurchaseSideBar from "../../components/purchaseregister/PurchaseSideBar";
import commoncss from "../../css/common.module.css";
import DataState from "../../purchase_elements/common/DataState/DataState";
import ERPTable from "../../purchase_elements/table/ERPTable";

const PurchaseListing = () => {
  const { id: routePurchaseID } = useParams();
  const [purchaseID, setPurchaseID] = useState("");
  const [showDataState, setShowDataState] = useState(true);
  const [tableType, setTableType] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [mappedFileName, setMappedFileName] = useState("");
  const [showAddRegisterModal, setShowAddRegisterModal] = useState(false);

  useEffect(() => {
    if (routePurchaseID) {
      setPurchaseID(routePurchaseID);
    }
  }, [routePurchaseID]);

  const handleFiltersApplied = (filters) => {
    setAppliedFilters(filters);
  };

  const handleNoDataFound = () => {
    setAppliedFilters([]);
  };

  useEffect(() => {
    if (showTable && tableType === null) {
      setTableType("excel");
    }
  }, [showTable, tableType]);

  return (
    <>
      <div style={{ display: "flex" }}>
        <PurchaseSideBar activeTab={"Listing"} purchaseID={purchaseID} />
        <div className={`${commoncss.widthScrHidden} px-3 py-2`}>
          <PurchaseregHeader
            PurchaseID={purchaseID}
            setMappedFileName={setMappedFileName}
            setShowDataState={setShowDataState}
            tableType={tableType}
            setTableType={setTableType}
            setShowTable={setShowTable}
            onFiltersApplied={handleFiltersApplied}
            showAddRegisterModal={showAddRegisterModal}
            setShowAddRegisterModal={setShowAddRegisterModal}
          />

          {showDataState && !showTable && (
            <DataState setShowAddRegisterModal={setShowAddRegisterModal} />
          )}
          {showTable && tableType === "excel" && (
            <DataTable
              PurchaseID={purchaseID}
              filters={appliedFilters}
              selectedFileName={mappedFileName}
              onNoDataFound={handleNoDataFound}
            />
          )}
          {showTable && tableType === "erp" && <ERPTable />}
        </div>
      </div>
    </>
  );
};

export default PurchaseListing;
